import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import Mentorship from "components/Homepage/Mentorship";
import ReadyToGrow from "components/Homepage/ReadyToGrow";
import Services from "components/Homepage/Services";
import HeroService from "components/Service/HeroService";
import ListofServiceNewStyle from "components/Service/ListofServiceNewStyle";
import ListServices from "components/Service/ListServices";
import MainService from "components/Service/MainSerive";
import MissionService from "components/Service/MissionService";
import QuoteService from "components/Service/QuoteSerive";
import React from "react";

const Service = () => {
  return (
    <div className="bg-darkbg">
      {/* <HeroService /> */}
      <MissionService />
      <QuoteService />
      <ListofServiceNewStyle />
      {/* <SocialMedia /> */}
      <ReadyToGrow />
    </div>
  );
};

export default Service;
